export default {
  TableHeadSubAgent: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.username',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.nickname',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.turnover',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.stake',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.member100',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.member',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.agent',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.company',
        attr: {
          colspan: 3,
        },
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadMember: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.username',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.nickname',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.turnover',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.stake',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.member100',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.company',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'memberbody.quotation',
        attr: {
          rowspan: 3,
          class: 'text-right',
        },
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadAgent: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.username',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.nickname',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.turnover',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.stake',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.member100',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.agent',
        attr: {
          colspan: 3,
        },
      },
      {
        displayName: 'memberbody.quotation',
        attr: {
          rowspan: 3,
          class: 'text-right',
        },
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.marketing',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.total',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadLog: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.info',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.activity',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.amount',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.result',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.level',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.balance',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.summarize',
        attr: {
          colspan: 99,
        },
        isCompanyHidden: true,
      },
    ],
    [
      {
        displayName: 'report.winloseSimple.datatable.member',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.agent',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.company',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.api',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadProvider: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.provider',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.whiteLabel',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.gameType',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.gameName',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.turnover',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.count',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.rtp',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.netWin',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winloseAMB',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.winloseProvider',
        attr: {
          class: 'text-right',
        },
      },
    ],
  ],
  TableHeadDateRange: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'Date',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'RangeTime',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'Count',
        attr: {
          class: 'text-center',
        },
      },
    ],
  ],
  TableHeadLogAdmin: [
    [
      {
        displayName: 'user.log.number',
      },
      {
        displayName: 'user.log.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'user.log.gameName',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'user.log.status',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'user.log.bet',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'user.log.before',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'user.log.after',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'user.log.winlose',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'user.log.ip',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'user.log.timestamp',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ],
};
